// test1961
(1961 && 0);
